<template>
  <section class="bannerBox">
	  <div class="bannerContent">
		  <!-- <h2>인기 게임 쿠폰</h2> -->
		  <p>长沙潇湘畅游网络科技有限公司成立于2019-11-28，法定代表人为高芬芳，注册资本为500万元，统一社会信用代码为91430100MA4R0UGU8Y，企业注册地址位于湖南省长沙市开福区月湖街道鸭子铺路1号163房5室，所属行业为研究和试验发展，经营范围包含：网络技术的研发；应用软件开发；经营增值电信业务；信息技术咨询服务；游戏软件设计制作；利用信息网络经营动漫产品；计算机销售。（依法须经批准的项目，经相关部门批准后方可开展经营活动，未经批准不得从事P2P网贷、股权众筹、互联网保险、资管及跨界从事金融、第三方支付、虚拟货币交易、ICO、非法外汇等互联网金融业务）。长沙潇湘畅游网络科技有限公司目前的经营状态为存续（在营、开业、在册）。
		  </p><!-- <a>모두 선택하여 구매</a> -->
	  </div>
  </section>
  <!-- <section class="richText bg1">
  	  <div class="richTextContent">
  		  <h2>您可以在这里享受最高的福利</h2>
  		  <p>이것은 인기 게임 교환 코드의 스토어입니다. 관심 있다면 100원만 있으면 게임 내 혜태 아이템을 획득할 수 있습니다.</p>
  	  </div>
  </section> -->
  <section class="bg1">
	  <div class="listBox" :class="{'pc':!isMobile(),'m':isMobile()}">
		 <!-- <h2 class="title">游戏</h2>
		  <div class="listItem">
			  <ul>
				<template v-for="(item,index) in goodList" :key="index">
					<li class="item">
						<div class="imgBox">
							<a href="javascript:;">
							<router-link :to="'/products/detail/'+item.id">
								<img src="https://qpyx-rlsb.oss-cn-shanghai.aliyuncs.com/2024/09/13/34a6fd3168854cbd8effcd32ab7c2299.png" />
							</router-link>
							</a>
						</div>
						<div class="desBox">
							<h3 class="title">
								<router-link :to="'/products/detail/'+item.id">
								武道将魂-无限合宠刷充服
								</router-link>
							</h3>
							<p class="price">
								<router-link :to="'/products/detail/'+item.id"><span class="onsale">立即试玩</span></router-link>
							</p>
						</div>
					</li>
				</template>
			  </ul>
		  </div> -->
		  
		  <!-- <swiper
		    :effect="'coverflow'"
			:grabCursor="true"
			:centeredSlides="true"
			:slidesPerView="'auto'"
			:coverflowEffect="{
			  rotate: 50,
			  stretch: 0,
			  depth: 100,
			  modifier: 1,
			  slideShadows: false,
			}"
			:pagination="true" 
		  	:style="{
		  	  '--swiper-pagination-color': '#000'
		  	}"
		    class="mySwiper"
		    >
		    <swiper-slide v-for="(item,index) in adList" :key="index">
		  		<div class="ad">
		  			<img :src="item.url">
		  		</div>
		  	</swiper-slide>
		  </swiper> -->
	  </div>
  </section>

</template>

<script setup>
import { ref, onMounted } from "vue";
import { getGoodList } from '@/api/index'
import { Swiper, SwiperSlide } from 'swiper/vue';
import { isMobile } from '@/utils/common.js'

import SwiperCore, { EffectCoverflow,Pagination,Navigation } from 'swiper/core';
SwiperCore.use([EffectCoverflow,Pagination,Navigation]);

import "swiper/components/effect-coverflow";

const adList = ref([
	{ url: require('@/assets/images/ad1.png') },
	{ url: require('@/assets/images/ad2.png') },
	{ url: require('@/assets/images/ad3.png') },
	{ url: require('@/assets/images/ad4.png') }
])

const goodList = ref([])

onMounted(()=>{
	getGoodList().then((res)=>{
		goodList.value = res.rows
	})
})

</script>
<style lang="less">
  @import '@/assets/css/common';
</style>
<style lang="less" scoped>
.bannerBox{
	width: 100%;min-height: 26rem;overflow: hidden;
	background: url('~@/assets/images/banner.jpg') no-repeat center top;
	background-size: 100%;position: relative;z-index: 1;
	&::after{
		content: '';display: block;position: absolute;top: 0;left: 0;
		width: 100%;height: 100%;background: rgba(18,18,18,0.2);z-index: 111;
		text-align: center;line-height: 26rem;color: #efefef;
		font-size: 2.4rem;font-weight: 400;
	}
	.bannerContent{
		position: absolute;color: #fff;text-align: center;z-index: 1111;
		left: 50%;bottom: 6rem;transform: translate(-50%,0);
		h2{
			font-size: 5.2rem;font-weight: 400;
		}
		p{
			margin-top: 1rem;font-size: 1.6rem;
		}
		a{
			display: inline-block;padding: 1.5rem 3rem;border: 1px solid #fff;color: #fff;
			letter-spacing: 0.1rem;margin-top: 2rem;box-sizing: border-box;font-size: 1.6rem;
			transition: box-shadow 0.1s ease;
			&:hover{
				box-shadow: 0 0 2px rgb(255,255,255);
			}
		}
	}
}
.richText{
	padding: 40px;box-sizing: border-box;padding-bottom: 0;
	.richTextContent{
		width: 100%;text-align: center;
		padding: 0 5rem;margin: 0 auto;box-sizing: border-box;
		h2{
			font-size: 2.4rem;font-weight: 400;
		}
		p{
			margin-top: 2rem;color: rgba(18,18,18,0.75);font-size: 1.6rem;
		}
	}
}
.mySwiper{
	margin-top: 3rem;
	.ad{
		position: relative;width: 100%;height: 170px;overflow: hidden;
		img{
			height: 100%;position: absolute;
			top: 0;left: 50%;transform: translate(-50%,0);
		}
	}
}
</style>
